import script from "./template4.vue?vue&type=script&setup=true&lang=js"
export * from "./template4.vue?vue&type=script&setup=true&lang=js"

import "./template4.vue?vue&type=style&index=0&id=4805f464&lang=less"

const __exports__ = script;

export default __exports__